<template>
    <el-dialog :title="titulo" :visible.sync="visivelLocal" width="540px" append-to-body :close-on-click-modal="false" @open="carregarOpcoes">
        <div v-loading="carregando">
            <el-form label-position="top">
                <el-form-item class="u-mt-10" label="Registro duplicado (será REMOVIDO)">
                    <el-select v-model="duplicadoId" filterable clearable placeholder="Selecione o duplicado" style="width: 100%;">
                        <el-option v-for="o in opcoes" :key="o.id" :label="rotulo(o)" :value="o.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="u-mt-10" label="Registro que permanece (mestre)">
                    <el-select v-model="mestreId" filterable clearable placeholder="Selecione o que permanece" style="width: 100%;">
                        <el-option v-for="o in opcoes" :key="o.id" :label="rotulo(o)" :value="o.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer">
            <el-button @click="visivelLocal = false">CANCELAR</el-button>
            <el-button type="primary" :loading="salvando" :disabled="!duplicadoId || !mestreId" @click="confirmar">UNIFICAR</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    name: 'unificar-cadastro',
    props: {
        visible: { type: Boolean, default: false },
        titulo: { type: String, default: 'Unificar cadastro duplicado' },
        urlOpcoes: { type: String, required: true },   // GET — retorna a lista de registros
        urlUnificar: { type: String, required: true }, // POST — { duplicado_id, mestre_id }
        campoLabel: { type: String, default: 'nome' }  // campo exibido no select
    },
    data: () => ({
        opcoes: [],
        carregando: false,
        salvando: false,
        duplicadoId: '',
        mestreId: ''
    }),
    computed: {
        visivelLocal: {
            get () { return this.visible },
            set (v) { this.$emit('update:visible', v) }
        }
    },
    methods: {
        rotulo (o) { return `#${o.id} — ${o[this.campoLabel]}` },
        carregarOpcoes () {
            this.duplicadoId = ''
            this.mestreId = ''
            this.opcoes = []
            this.carregando = true
            this.$axios.get(`${this.$store.state.config.baseUrlApi}${this.urlOpcoes}`, this.$store.getters.getHeaderAuth).then(r => {
                this.carregando = false
                this.opcoes = Array.isArray(r.data) ? r.data : (r.data && r.data.data ? r.data.data : [])
            }).catch(e => { this.carregando = false; this.$store.commit('throwException', e) })
        },
        confirmar () {
            if (this.duplicadoId === this.mestreId) {
                window.eventBus.$emit('alert', { msg: 'Selecione dois registros diferentes.', type: 'warning' })
                return
            }
            this.$msgbox.confirm('Confirma a unificação? O registro duplicado será removido definitivamente e seus vínculos passarão para o registro mestre.', 'Atenção', { confirmButtonText: 'Sim, unificar', cancelButtonText: 'Não', type: 'warning' }).then(() => {
                this.salvando = true
                this.$axios.post(`${this.$store.state.config.baseUrlApi}${this.urlUnificar}`, { duplicado_id: this.duplicadoId, mestre_id: this.mestreId }, this.$store.getters.getHeaderAuth).then(r => {
                    this.salvando = false
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Cadastros unificados com sucesso.', type: 'success' })
                    this.visivelLocal = false
                    this.$emit('done')
                }).catch(e => { this.salvando = false; this.$store.commit('throwException', e) })
            }).catch(() => {})
        }
    }
}
</script>
